import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../NavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import FAQInfoDataService from "@/services/FAQInfoDataService";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const isShowing = ref(false);
const i18n = useI18n();
const faqInfo = reactive([]);
const searchfaqInfo = reactive([]);
const search = ref("");
const getData = ref(false);

onMounted(function () {
  isLoading.value = true;
  getBackNoFAQ();
});

/** newsAndFAQのページに遷移する関数 */
const linkBack = () => {
  router.push("/");
};

const getBackNoFAQ = () => {
  isLoading.value = true;
  faqInfo.splice(0);
  searchfaqInfo.splice(0);
  const data = { isShowing: isShowing.value };

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // get FAQ
  FAQInfoDataService.getAllFAQ(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        for (let info of response.data) {
          faqInfo.push(info);
          searchfaqInfo.push(info);
        }
      }
      getData.value = true;
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err009");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** プレビューボタン押下時の処理関数 */
const showFaq = (filename: any) => {
  const data = {'filename': filename};

  FAQInfoDataService.accessToFile(data)
  .then((response: ResponseData) => {
    window.open(response.data)?.focus();
  })
};

onUpdated(function () {
  isLoading.value = false;
});

const changeEvent = () => {
  isLoading.value = true;
  faqInfo.splice(0);
  for (let info of searchfaqInfo) {
    if (info.Subject.toLowerCase().match(search.value.toLowerCase())) {
      faqInfo.push(info);
    }
  }
};

const __returned__ = { router, isLoading, alertMessage, alertState, isShowing, i18n, faqInfo, searchfaqInfo, search, getData, linkBack, getBackNoFAQ, showFaq, changeEvent, Navigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})